module.exports = __webpack_public_path__ + "img/N2M10.088d5eca.jpg";